import Cookies from 'js-cookie';
import { disableBodyScroll, enableBodyScroll, getCookiesAllowed, waitForVideo } from './helpers';

const initPromoPopup = () => {
	const modal = document.querySelector('.promo-popup');
	if (!modal) return;

	const urlParam = modal.dataset.urlParam || 'video-promotion';
	const cookieName = 'tc_popup_closed';
	const params = new URLSearchParams(window.location.search);
	const forceOpen = params.has(urlParam);
	const currentScopeId = urlParam;

	const lastSeenScopeId = Cookies.get(cookieName);
	const hasCookieForCurrentVideo =
		typeof lastSeenScopeId !== 'undefined' &&
		lastSeenScopeId === currentScopeId;

	const video = modal.querySelector('video');
	const closeBtn = modal.querySelector('[data-promo-close]');
	const soundBtn = modal.querySelector('[data-promo-sound]');
	const toggleBtn = modal.querySelector('[data-promo-toggle]');
	const soundOpenIcon = soundBtn?.querySelector('.tci-sound-open');
	const soundCloseIcon = soundBtn?.querySelector('.tci-sound-close');
	const fallback = modal.querySelector('.promo-popup__image');

	if (toggleBtn) toggleBtn.classList.remove('is-active');

	if (hasCookieForCurrentVideo && !forceOpen) return;

	const setClosedCookie = () => {
		Cookies.set(cookieName, currentScopeId, {
			expires: 30,
			path: '/',
			sameSite: 'Lax',
		});
	};

	const updateSoundUI = () => {
		if (!soundBtn || !video) return;
		const muted = video.muted;
		soundBtn.classList.toggle('is-muted', muted);
		if (soundOpenIcon) soundOpenIcon.style.display = muted ? 'none' : 'inline-flex';
		if (soundCloseIcon) soundCloseIcon.style.display = muted ? 'inline-flex' : 'none';
		soundBtn.setAttribute('aria-pressed', muted ? 'false' : 'true');
	};

	const syncToggleLabel = () => {
		if (!toggleBtn || !video) return;
		if (video.paused) toggleBtn.classList.add('is-active');
		else toggleBtn.classList.remove('is-active');
	};

	const playWithDelay = () => {
		if (!video) return;

		video.pause();
		toggleBtn?.classList.add('is-active');

		setTimeout(async () => {
			try {
				await waitForVideo(video);

				video.muted = true;
				updateSoundUI();
				await video.play();

				fallback?.classList.remove('is-visible');
			} catch {
				fallback?.classList.add('is-visible');
			} finally {
				toggleBtn?.classList.remove('is-active');
				syncToggleLabel();
			}
		}, 400);
	};

	const open = () => {
		toggleBtn?.classList.add('is-active');
		modal.classList.add('show');
		modal.removeAttribute('aria-hidden');
		document.body.classList.add('has-promo-popup-open');
		disableBodyScroll();
		playWithDelay();
	};

	fallback?.addEventListener('click', () => {
		if (!fallback.classList.contains('is-visible') || !video) return;

		fallback.classList.remove('is-visible');
		video.muted = false;
		updateSoundUI();
		video.play().catch(() => {});
	});

	const close = () => {
		if (video) {
			video.pause();
			video.currentTime = 0;
		}
		modal.classList.remove('show');
		modal.setAttribute('aria-hidden', 'true');
		document.body.classList.remove('has-promo-popup-open');
		setClosedCookie();
		enableBodyScroll();
	};

	const togglePlayPause = () => {
		if (!video) return;
		if (video.paused) {
			video.play().catch(() => {});
		} else {
			video.pause();
		}
		syncToggleLabel();
	};

	const toggleSound = () => {
		if (!video) return;
		video.muted = !video.muted;
		updateSoundUI();
	};

	if (video) {
		video.addEventListener('play', syncToggleLabel);
		video.addEventListener('pause', syncToggleLabel);
	}

	open();

	if (closeBtn) closeBtn.addEventListener('click', close);
	if (soundBtn) soundBtn.addEventListener('click', toggleSound);
	if (toggleBtn) toggleBtn.addEventListener('click', togglePlayPause);
	if (video) video.addEventListener('click', togglePlayPause);

	modal.addEventListener('click', (e) => {
		if (e.target === modal) close();
	});

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') close();
	});
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initPromoPopup);
} else {
	initPromoPopup();
}
